import React from "react";
import { NodeViewWrapper } from "@tiptap/react";
import { HubIcon } from "../../HubIcon";

export const ENTITY_CONFIG = {
  work_order: { icon: "FileText", color: "#6366f1", bg: "#eef2ff", label: "Work Orders" },
  part: { icon: "Settings", color: "#0891b2", bg: "#ecfeff", label: "Parts" },
  quote: { icon: "Folder", color: "#d97706", bg: "#fffbeb", label: "Quotes" },
  order: { icon: "ShoppingCart", color: "#16a34a", bg: "#f0fdf4", label: "Orders" },
  customer: { icon: "User", color: "#7c3aed", bg: "#f5f3ff", label: "Customers" },
};

const EntityLinkComponent = ({ node }) => {
  const { entityType, label } = node.attrs;
  const config = ENTITY_CONFIG[entityType] || {
    icon: "Link",
    color: "#6b7280",
    bg: "#f3f4f6",
  };

  return (
    <NodeViewWrapper as="span" style={{ display: "inline" }}>
      <span
        contentEditable={false}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 3,
          padding: "1px 6px",
          borderRadius: 4,
          fontSize: 12,
          fontWeight: 500,
          background: config.bg,
          color: config.color,
          userSelect: "none",
          lineHeight: "18px",
        }}
      >
        <HubIcon icon={config.icon} size={11} />
        {label}
      </span>
    </NodeViewWrapper>
  );
};

export default EntityLinkComponent;
